import DestinationContainer from './DestinationContainer';

export default DestinationContainer;
